jQuery(function ($) {
    $(document).ready(function () {
        var SITE_URL = $('.w-nav-brand').attr('href');
        var AJAX_URL = SITE_URL + '/wp-admin/admin-ajax.php';
        
    });
});